export default {
    addToCart({ commit }, cartHandler) {
        commit('ADD_TO_CART', cartHandler);
    },

    removeFromCart({ commit }, cartHandler) {
        commit('REMOVE_FROM_CART', cartHandler);
    },

    updateCartItem({ commit }, cartHandler) {
        commit('UPDATE_ITEM_FROM_CART', cartHandler);
    },
    
    clearCart({ commit }) {
        commit('CLEAR_CART');
    },
};